// Generated from BaserowFormula.g4 by ANTLR 4.9
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete generic visitor for a parse tree produced by BaserowFormula.

export default class BaserowFormulaVisitor extends antlr4.tree.ParseTreeVisitor {

	// Visit a parse tree produced by BaserowFormula#root.
	visitRoot(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#FieldReference.
	visitFieldReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#StringLiteral.
	visitStringLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#Brackets.
	visitBrackets(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#BooleanLiteral.
	visitBooleanLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#RightWhitespaceOrComments.
	visitRightWhitespaceOrComments(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#DecimalLiteral.
	visitDecimalLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#LeftWhitespaceOrComments.
	visitLeftWhitespaceOrComments(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#FunctionCall.
	visitFunctionCall(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#FieldByIdReference.
	visitFieldByIdReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#LookupFieldReference.
	visitLookupFieldReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#IntegerLiteral.
	visitIntegerLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#BinaryOp.
	visitBinaryOp(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#ws_or_comment.
	visitWs_or_comment(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#func_name.
	visitFunc_name(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#field_reference.
	visitField_reference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by BaserowFormula#identifier.
	visitIdentifier(ctx) {
	  return this.visitChildren(ctx);
	}



}